var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-file"},[_c('input',{staticClass:"custom-file-input",attrs:{"id":"file-uploader","type":"file","data-target":"file-uploader"},on:{"change":_vm.handleFileUpload}}),_c('button',{staticClass:"custom-file-label popup-label--mobile",attrs:{"for":"customFile"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }